import { render, staticRenderFns } from "./SampleQuestion.vue?vue&type=template&id=2d22a377"
import script from "./SampleQuestion.vue?vue&type=script&lang=js"
export * from "./SampleQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports